import { render } from "./UserTenantManagement.vue?vue&type=template&id=52f885aa"
import script from "./UserTenantManagement.vue?vue&type=script&lang=js"
export * from "./UserTenantManagement.vue?vue&type=script&lang=js"

import "./UserTenantManagement.vue?vue&type=style&index=0&id=52f885aa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__